import React from "react";

import { useResources } from "~/screens/Hub/Resources/hooks/useResources";
import { Title, usePageTitle } from "~/shared";
import { ResourceGroup } from "~/shared.types";
import HighlightedText from "~/ui/common/HighlightedText";
import { customIcons } from "~/ui/common/Icons";
import { CommunitySection } from "./components/CommunitySection";
import { GuidesSection } from "./components/GuidesSection";
import { Meno101Section } from "./components/Meno101Section";
import { WatchSection } from "./components/WatchSection";

const ResourcesGroup = {
  MENO_101: "Meno 101",
  ELEKTRA_GUIDES_TO_MENOPAUSE: "Elektra’s Guides to Menopause",
  ELEKTRA_COMMUNITY: "Elektra Community",
} as const;

export const Resources = () => {
  usePageTitle("Resources");
  const { data, isLoading } = useResources();
  const resourceGroupData = data?.data ?? [];

  const findResourceGroup = (groupName: string) =>
    resourceGroupData.find(
      (resourceGroup: ResourceGroup) => resourceGroup.group === groupName,
    );

  const meno101Resources =
    findResourceGroup(ResourcesGroup.MENO_101)?.resources ?? [];
  const elektraGuidesToMenopauseResources =
    findResourceGroup(ResourcesGroup.ELEKTRA_GUIDES_TO_MENOPAUSE)?.resources ??
    [];
  const elektraCommunityResources =
    findResourceGroup(ResourcesGroup.ELEKTRA_COMMUNITY)?.resources ?? [];

  if (isLoading) {
    return (
      <div className="py-16 text-center">
        <customIcons.SpinnerIcon className="text-violet size-10 animate-spin" />
      </div>
    );
  }

  return (
    <div className="font-sans">
      <header className="mb-8">
        <Title>
          <HighlightedText>Resources</HighlightedText>
        </Title>
        <h2 className="text-indigo text-lg">
          MD-vetted readings, product recommendations, and more
        </h2>
      </header>
      <div className="space-y-16">
        <Meno101Section resources={meno101Resources} />
        <GuidesSection resources={elektraGuidesToMenopauseResources} />
        <CommunitySection resources={elektraCommunityResources} />
        <WatchSection />
      </div>
    </div>
  );
};
